import { addEventMergeIdIfVariationChangedAndExists } from '../../_common/client/tracking';
import { BaseComponent } from '../../base-component';

export class RecoSponsoredComponent extends BaseComponent {
    public static ROOT_SELECTOR = '.js_pdp_reco-sponsored';
    public rootSelector = RecoSponsoredComponent.ROOT_SELECTOR;

    public async onHtmlLoaded(): Promise<void> {
        if (!this.isPresent()) {
            return;
        }

        const variationId = this.getRootElement().dataset.variationId;
        if (!variationId) {
            return;
        }

        window.o_auction_presentation?.api.loadSponsoredArticlesForDetailView(
            addEventMergeIdIfVariationChangedAndExists({
                variationId,
                sponsoredArticlesCinemaTarget: this.rootSelector,
            })
        );
    }
}
